module.exports = __webpack_public_path__ + "static/media/giraffe_bots.be08c711.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stock/botswana/giraffe_bots.jpg
// module id = 297
// module chunks = 0